export const toPercentage = (num) => (
	Number.isNaN(num) ? '%' : `${(num * 100).toFixed(2)}%`
);
